import { useMediaQuery } from '@material-ui/core';

import { businessNameFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/businessNameFieldColumn';
import { businessTypeFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/businessTypeFieldColumn';
import { contactPersonFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/contactPersonFieldColumn';
import { corporateIdNumberFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/corporateIdNumberFieldColumn';
import { createdAtFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/createdAtFieldColumn';
import { creationDateAndMerchantNameMobileFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/creationDateAndMerchantNameMobileFieldColumn';
import { statusFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/statusFieldColumn';
import { toMerchantDetailFieldColumn } from '@/components/modules/MerchantsList/components/MerchantDataGridFields/components/toMerchantDetailFieldColumn';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export function MerchantDataGridFields({ showInternalData }: { showInternalData: boolean }) {
  const { breakpoints } = useCustomTheme();

  const isDownMd = useMediaQuery(breakpoints.down('md'));

  const defaultMerchantFields = {
    desktop: [
      businessTypeFieldColumn({ flex: 0.2 }),
      businessNameFieldColumn({ flex: showInternalData ? 0.55 : 1.41 }),
      corporateIdNumberFieldColumn({ flex: 0.4 }),
      ...(showInternalData ? [contactPersonFieldColumn({ flex: 0.5 })] : []),
      createdAtFieldColumn({ flex: 0.35 }),
      ...(showInternalData ? [statusFieldColumn({ flex: 0.4 })] : []),
      toMerchantDetailFieldColumn({ flex: 0.15 }),
    ],
    mobile: [creationDateAndMerchantNameMobileFieldColumn({ flex: 1 })],
  };

  const DataGridFields = {
    merchant: defaultMerchantFields.desktop,
  };

  const MobileDataGridFields = {
    merchant: defaultMerchantFields.mobile,
  };

  return isDownMd ? MobileDataGridFields.merchant : DataGridFields.merchant;
}
